import $http from '@/utils/request/index.js'
export const login = data => { // 登录
  return $http({
    url: '/login',
    data
  })
}
